<template>
  <main class="content">
    <section class="main-section">
      <img src="/assets/hero-icons/successful-registration.svg">
      <div class="successful-text-container">
        <h1 class="successful-title">{{ adminText('adminAll.uspjesna_registracija_2e9932', 'Uspješna registracija') }}</h1>
        <h5 class="successful-text">{{ adminText('adminAll.uskoro_ces_zaprimiti_email_za_verifikaciju_registracije_782c95', 'Uskoro ćeš zaprimiti email za verifikaciju registracije.') }}</h5>
      </div>
    </section>
  </main>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext, AdminAllMessages],
  data() {
    return {}
  },
}
</script>

<style scoped>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}
.main-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 42rem;
  justify-self: center;
}
.successful-text-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  margin-top: 4.5rem;
}
.successful-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 72px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.03em;
  color: #333333;
}
.successful-text {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  text-align: center;
  letter-spacing: -0.03em;
  color: #333333;
  max-width: 28rem;
}
</style>
